import { BaseEntityDto } from '../common/base-entity.dto';
import { AdminNotificationType, UserRole } from '../../enums';

export interface AdminNotificationDto extends BaseEntityDto {
  title: string;
  message: string;
  notificationType: AdminNotificationType;
  targetRoles: UserRole[];
  totalRecipients: number;
  sentDate: string; // DateTime as ISO string
  sentByUserId: string; // Guid
  sentByUserName: string;
  isUrgent: boolean;
  actionButtonText?: string | null;
  actionUrl?: string | null;
}
